import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

interface RevenueByDaysRequestParamsType {
  stores_ids?: string;
  date_from?: string;
  date_to?: string;
}

export interface RevenueByDaysParamsType {
  currency: string;
  company_id: string;
  resultKey?: string;
  successCallback?: Function;
  errorCallback?: Function;
  params?: RevenueByDaysRequestParamsType;
}

export default ({
  resultKey = 'revenueByDays',
  successCallback,
  errorCallback,
  params,
  company_id,
  currency,
}: RevenueByDaysParamsType) =>
  requestAsync({
    url: endpoints.getRevenueByDaysUrl(company_id, currency, params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getRevenueByDaysUrl(company_id, currency, params),
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
